/* eslint-disable no-console */
<template>
  <div class="delivery-date-controller-wrapper">
    <input :value="approvedDate" class="basket-group-inner-input calendar-date"
           :placeholder="placeholder" @click="switchCalendar(true)" readonly="readonly">
    <div
      id="single-date-picker"
      class="single-date-picker__calendar-view"
    v-if="visible">
      <CalendarMonthHeader
        :year="year"
        :month="month"
        @toggleMonth="toggleMonth"
      />
      <div class="calender-body">
        <CalendarMonth
          :dates-per-week="datesPerWeek"
          :is-today="isToday"
          :is-selected="isSelected"
          :week-start-day="weekStartDay"
          :min-day="minDay"
          :max-day="maxDay"
          @selectDate="setSelectedDate"
        />
        <TimeRangeSelector :key="'time-range-pickup'" v-if="isDelivery && timerDates.dateStart !== null && timerDates.dateFinish !== null"
                           :date-start="timerDates.dateStart" :date-finish="timerDates.dateFinish"
                           @selectTime="setSelectedTime"
                           @slotsChanged="onSlotsChanged"
                           :stored-time-range="selectedTimeRangeInterval"></TimeRangeSelector>

        <TimerInput v-if="!isDelivery" :date-start="dateStart" :date-finish="timerDates.dateFinish"
                    :phrases="phrases" @selectTime="setSelectedTimeInput"
                    :selected-time="selectedTimeRangeInterval"
                    :selected-date="formattedDate(deferOrderDate, '-')"></TimerInput>

        <div v-if="isAvailableOrderTimeApprove || !isDelivery" class="basket-group-button active" @click="approveSelected">
          Выбрать {{ selectedDate }}
        </div>
        <div v-for="(error, index) in errors" :key="index" class="basket-note-text">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarMonthHeader from './components/CalendarMonthHeader';
import CalendarMonth from './components/CalendarMonth';
import {mapGetters} from "vuex";
import TimeRangeSelector from "./components/TimeRangeSelector.vue";
import TimerInput from "@/libs/calendar/components/TimeInput.vue";

const NUM_DAYS_IN_WEEK = 7;

export default {
  name: 'CalendarView',
  components: {
    TimerInput,
    TimeRangeSelector,
    CalendarMonthHeader,
    CalendarMonth
  },
  props: {
    date: {
      type: Object,
      default: () => null
    },
    firstDayOfWeek: {
      type: Number,
      default: 0,
      validator: (value) => (value >= 0) && (value <= 6)
    },
    minDate: {
      type: Object,
      default: () => null
    },
    maxDate: {
      type: Object,
      default: () => null
    },
    placeholder: {
      type: String,
      default: () => null
    },
    pizzeriaSchedule: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isDelivery: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    phrases: {
      type: Object
    }
  },
  data() {
    return {
      year: 0,
      month: 0,
      todayDate: 0,
      todayYear: 0,
      todayMonth: 0,
      weekStartDay: 0,
      isAvailableOrderTimeApprove: false,
      selectedTimeRangeInterval: null,
      errors: [],
      deferOrderDate: null,
      deferOrderTime: null,
      currentTimestamp: 0,
      intervalId: null,
    }
  },
  computed: {
    ...mapGetters('basket', {
      visible: 'isOpenCalendar'
    }),
    ...mapGetters('app', {
      delayThresholdPickup: 'getDelayThresholdPickup',
      isPizzeriaClosed: 'getIsPizzeriaClosed',
    }),
    numDays() {
      return new Date(this.year, this.month + 1, 0).getDate();
    },
    firstDay() {
      const startDay = new Date(this.year, this.month, 1).getDay() - this.weekStartDay;
      if (startDay < 0) return NUM_DAYS_IN_WEEK - Math.abs(startDay);
      return startDay;
    },
    lastDay() {
      const lastDay = new Date(this.year, this.month + 1, 0).getDay() - this.weekStartDay;
      if (lastDay < 0) return NUM_DAYS_IN_WEEK - Math.abs(lastDay);
      return lastDay;
    },
    numDaysInFirstWeek() {
      return NUM_DAYS_IN_WEEK - this.firstDay;
    },
    numDaysInLastWeek() {
      return this.lastDay + 1;
    },
    numWeeks() {
      const daysLeft = this.numDays - this.numDaysInFirstWeek - this.numDaysInLastWeek;
      return daysLeft / 7 + 2;
    },
    numFullWeeks() {
      return this.numWeeks - 2;
    },
    datesInFirstWeek() {
      return this.generateDatesInWeek(1, this.firstDay, this.numDaysInFirstWeek);
    },
    datesInLastWeek() {
      return this.generateDatesInWeek(this.numDays - this.numDaysInLastWeek + 1, 0, this.numDaysInLastWeek);
    },
    datesInMiddleWeeks() {
      const startDates = [];
      for (let i = 0; i < this.numFullWeeks; i += 1) {
        startDates[i] = this.datesInFirstWeek[6] + 1 + i*7;
      }
      return startDates.map(startDate => {
        return this.generateDatesInWeek(startDate, 0, 7);
      });
    },
    datesPerWeek() {
      return [
        this.datesInFirstWeek,
        ...this.datesInMiddleWeeks,
        this.datesInLastWeek
      ]
    },
    isCurrentMonth() {
      return this.todayMonth === this.month;
    },
    isCurrentYear() {
      return this.todayYear === this.year;
    },
    isToday() {
      return (this.isCurrentMonth && this.isCurrentYear) ? this.todayDate : 0;
    },
    isSelected() {
      if (this.deferOrderDate) {
        return (this.deferOrderDate.year === this.year) && (this.deferOrderDate.month === this.month) ? this.deferOrderDate.date : 0;
      }
      return 0;
    },
    minDay(){
      return this.month === this.minDate.month ? this.minDate.day : 1;
    },
    maxDay(){
      return this.month === this.maxDate.month ? this.maxDate.day :
          new Date(this.year, this.month + 1, 0).getDate();
    },
    selectedDate(){
      if(this.deferOrderDate === null){
        return null;
      }
      if(this.deferOrderDate.date !== null) {
        const date = ("0" + (this.deferOrderDate.date).toString()).slice(-2);
        const month = ("0" + (this.deferOrderDate.month + 1).toString()).slice(-2);
        return [date, month, this.deferOrderDate.year].join(".") + this.extractTime(this.selectedTimeRangeInterval)
      }
      return null;
    },
    timerDates: function (){
      const orderDate = this.formattedDate(this.deferOrderDate, "");
      const deliveryType = this.isDelivery ? "delivery" : "pickup";
      const schedule = this.pizzeriaSchedule[orderDate] ? this.pizzeriaSchedule[orderDate]['preorder'][deliveryType] : null;
      return {
          dateStart: schedule['start'],
          dateFinish: schedule['finish']
      };
    },
    dateStart: function (){
      const date = new Date(this.currentTimestamp);
      const isOpenPizza = !this.isPizzeriaClosed;
      const orderDate = this.formattedDate(this.deferOrderDate, "");
      const currentDate = this.formattedDate({year: date.getFullYear(), month: date.getMonth(), date: date.getDate()}, "");
      const isTodayOrder = orderDate === currentDate;
      const closestPickupOrderTime = this.formatLocal(new Date(this.currentTimestamp + (this.delayThresholdPickup * 1000)));
      const startDate = (isOpenPizza && isTodayOrder) ? closestPickupOrderTime : this.timerDates['dateStart'];
      return startDate;
    },
    approvedDate: function () {
      if (this.deferOrderTime === null){
        return this.formattedUserDate(this.deferOrderDate);
      }
      return this.formattedUserDate(this.deferOrderDate) + " " + this.deferOrderTime;
    }
  },
  created() {
    const date = new Date();
    const defaultDate = this.minDate.day;
    if (this.date) {
      this.year = this.date.year;
      this.month = this.date.month;
      this.deferOrderDate = {
        year: this.date.year,
        month: this.date.month,
        date: defaultDate
      };
    } else {
      this.deferOrderDate = {
        year: date.getFullYear(),
        month: date.getMonth(),
        date: defaultDate
      };
    }
    this.todayDate = date.getDate();
    this.todayYear = date.getFullYear();
    this.todayMonth = date.getMonth();
    this.weekStartDay = (this.firstDayOfWeek >= 0 && this.firstDayOfWeek <= 6) ? this.firstDayOfWeek : 0;

    if(this.intervalId === null) {
      this.currentTimestamp = date.getTime();
      this.intervalId = setInterval(() => {
        this.currentTimestamp += 1000;
      }, 1000);
    }
  },
  methods: {
    extractTime(){
      if(this.selectedTimeRangeInterval === null){
        return "";
      }
      return " " + this.selectedTimeRangeInterval;
    },
    generateDatesInWeek(startDate, startDay, numDays) {
      const datesInWeek = new Array(7).fill(0);
      for (let i = 0; i < numDays; i+=1) {
        datesInWeek[startDay + i] = startDate + i;
      }
      return datesInWeek;
    },
    toggleMonth(direction) {
      let newMonth = this.month + Number(direction);
      let newYear = this.year;
      if (newMonth < 0) {
        newMonth = 11;
        newYear -= 1;
      }
      if (newMonth > 11) {
        newMonth = 0;
        newYear += 1;
      }
      if(!this.checkMonth({month: newMonth, year: newYear})) {
        return;
      }

      if (newYear >= 1970) {
        this.month = newMonth;
        this.year = newYear;
      }
    },
    checkMonth(date) {
      const month = date.month === 0 ? 12 : date.month;
      const minMonth = this.minDate.month === 0 ? 12 : this.minDate.month;
      const maxMonth = this.maxDate.month === 0 ? 12 : this.maxDate.month;
      return (month >= minMonth && date.year >= this.minDate.year &&
          month <= maxMonth && date.year <= this.maxDate.year);
    },
    setSelectedDate(date) {
      if (date) {
        this.deferOrderDate = {
          year: this.year,
          month: this.month,
          date: date
        };
      }
    },
    setSelectedTime(value){
      this.selectedTimeRangeInterval = value;
    },
    setSelectedTimeInput(value){
      this.selectedTimeRangeInterval = value;
      this.deferOrderTime = null;
      if(value === null){
        this.$emit('approveOrderDateTime', {time: null});
      }
    },
    switchCalendar(value){
      this.$store.commit('basket/setOpenCalendar', value);
    },
    approveSelected(){
      this.errors = [];
      if(this.selectedTimeRangeInterval === null){
        this.errors.push("Выберите время");
        return;
      }
      this.deferOrderTime = this.selectedTimeRangeInterval;
      this.$emit('approveOrderDateTime', {date: this.deferOrderDate, time: this.deferOrderTime});
      this.switchCalendar(false);
    },
    onSlotsChanged(value){
      this.isAvailableOrderTimeApprove = value.length > 0;
    },
    formattedDate(date, delimiter){
      return [date.year, ("0" + (date.month + 1)).slice(-2), ("0" + (date.date)).slice(-2)].join(delimiter);
    },
    formattedUserDate(date){
      return [("0" + (date.date)).slice(-2), ("0" + (date.month + 1)).slice(-2), date.year].join(".");
    },
    pad(n){
      return String(n).padStart(2,'0');
    },
    formatLocal(date = new Date()){
      const comp = this;
      return [
        date.getFullYear(),
        comp.pad(date.getMonth() + 1),
        comp.pad(date.getDate())
      ].join('-') + ' ' + [
        comp.pad(date.getHours()),
        comp.pad(date.getMinutes()),
        comp.pad(date.getSeconds())
      ].join(':');
    }
  },
  beforeDestroy() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
</script>

<style lang="scss" scoped>
  .delivery-date-controller-wrapper{
    width: 100%;
  }
  #single-date-picker {
    font-family: "Panton Semibold", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000;
    background: #fff;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
  }
  .calendar-date{
    width: 100%;
    margin: 0;
    font-size: 1rem;
  }
  .calender-body{
    border: 1px solid #eaeaea;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .basket-group-button{
      font-size: 14px;
      background-color: #809f36;
      border-color: #809f36;
      margin: 0;
    }
  }
</style>